var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      ref: "appLayout",
      attrs: {
        page: "/people",
        pageTitle: "People",
        tabs: true,
        selectedPeople: _vm.selectedPeople,
        nearMe: _vm.nearMe,
        market: _vm.market,
        retentionGroup: _vm.retentionGroup,
        showArchived: _vm.showArchived,
        showAllStudents: _vm.showAllStudents,
        fabLoading: _vm.loading,
        fabIcon: _vm.selectedPeople.length ? "email" : "add",
        marketOptions: _vm.marketOptions,
      },
      on: {
        fabAction: function ($event) {
          _vm.selectedPeople.length
            ? _vm.getUserEmails()
            : (_vm.userCreate = true)
        },
        pageSearch: function ($event) {
          _vm.search = $event
        },
      },
      scopedSlots: _vm._u([
        {
          key: "tabs",
          fn: function () {
            return [
              _c(
                "v-tabs",
                {
                  staticClass: "custom-tabs",
                  attrs: { "background-color": "transparent", height: "42px" },
                  model: {
                    value: _vm.selectedTab,
                    callback: function ($$v) {
                      _vm.selectedTab = $$v
                    },
                    expression: "selectedTab",
                  },
                },
                _vm._l(_vm.tabList, function (tab) {
                  return _c(
                    "v-tab",
                    {
                      key: tab.slug,
                      staticClass: "no-link",
                      attrs: { href: `/people/${tab.slug}` },
                    },
                    [
                      _c(
                        "Link",
                        {
                          staticClass:
                            "no-link flex align-center justify-center min-h-full",
                          attrs: {
                            href: `/people/${tab.slug}`,
                            "preserve-state": "",
                          },
                          on: {
                            click: function ($event) {
                              _vm.selectedPeople = []
                            },
                          },
                        },
                        [_vm._v(_vm._s(tab.title))]
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "v-tabs-items",
        { attrs: { value: _vm.selectedTab, touchless: "" } },
        _vm._l(_vm.tabList, function (tab) {
          return _c(
            "div",
            { key: tab.slug },
            [
              _vm.selectedTab == `/people/${tab.slug}`
                ? _c(
                    "v-tab-item",
                    {
                      attrs: {
                        value: `/people/${tab.slug}`,
                        transition: false,
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "pa-1 animate__animated animate__fadeIn",
                        },
                        [
                          _c("UserList", {
                            ref: "userList",
                            refInFor: true,
                            attrs: {
                              role: tab.slug,
                              people: _vm.getPeople(tab.slug),
                              headers: _vm.getHeaders(tab.slug),
                              search: _vm.search,
                              groupBy: _vm.groupBy,
                            },
                            on: {
                              selectedPeople: function ($event) {
                                _vm.selectedPeople = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.userCreate
        ? _c("UserCreate", {
            attrs: {
              errors: _vm.$page.props.errors,
              mode: {
                Teacher: _vm.selectedTab.includes("teachers"),
                Student: _vm.selectedTab.includes("students"),
                Staff: _vm.selectedTab.includes("staff"),
              },
            },
            on: {
              reset: function ($event) {
                _vm.userCreate = false
              },
              success: function ($event) {
                _vm.userCreate = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.composeEmail
        ? _c("ComposeEmail", {
            attrs: {
              emails: _vm.selectedEmails,
              signature: "",
              sendAsStudio: "",
              tinyMCE: "",
              user: _vm.$page.props.auth.user,
              errors: _vm.errors,
            },
            on: {
              success: function ($event) {
                return _vm.emailSuccess()
              },
              reset: function ($event) {
                _vm.closeModal(() => (_vm.composeEmail = false))
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }